import type { Reducer } from 'redux';

import type { ConvertLegacyIdAction } from '../../domains/legacyId/actions.types';
import { getId as getMapId } from '../../domains/legacyId/getId';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import type { LegacyIdsToGlobalIds } from './types';

export type LegacyIdAction = ConvertLegacyIdAction;

const initialState: LegacyIdsToGlobalIds = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LegacyIdsToGlobalIds> = (state = initialState, action: LegacyIdAction) => {
  switch (action.type) {
    case 'LEGACYID.CONVERT_LEGACY_ID_PENDING': {
      const { legacyId, mappedType } = action.payload;

      return moveToPending(state, [getMapId(legacyId, mappedType)]);
    }
    case 'LEGACYID.CONVERT_LEGACY_ID_FULFILLED': {
      const { legacyId, id, mappedType } = action.payload;

      return moveToFulfilled(state, {
        [getMapId(legacyId, mappedType)]: { legacyId, id },
      });
    }
    case 'LEGACYID.CONVERT_LEGACY_ID_REJECTED': {
      const { legacyId, mappedType, error } = action.payload;

      return moveToRejected(state, [getMapId(legacyId, mappedType)], error);
    }
    default:
      return state;
  }
};

export default reducer;
